<a class="banner-icon" [matMenuTriggerFor]="appMenu" matTooltip="Menu" matTooltipPosition="below">
    <fa-icon [icon]="menuIcon"></fa-icon>
</a>
<mat-menu #appMenu="matMenu" class="avmup-menu">
    <a class="avmup-menu-item mat-mdc-menu-item mat-mdc-menu-item" matTooltip="Téléchargement du guide utilisateur" matTooltipPosition="left" matTooltipShowDelay="1000">
        <fa-icon [icon]="handbookIcon"></fa-icon>
        Guide Utilisateur
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item" matTooltip="Téléchargement du guide d'administration" matTooltipPosition="left" matTooltipShowDelay="1000">
        <fa-icon [icon]="handbookIcon"></fa-icon>
        Guide Administrateur
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item" matTooltip="Afficher la foire aux questions" matTooltipPosition="left" matTooltipShowDelay="1000">
        <fa-icon [icon]="faqIcon" class="faq-icon"></fa-icon>
        FAQ
    </a>
    <a class="avmup-menu-item mat-mdc-menu-item" matTooltip="Changer mot de passe" matTooltipPosition="left" matTooltipShowDelay="1000" (click)="modifyPassword()">
        <fa-icon [icon]="faKey"></fa-icon>
        <span>Changer mot de passe</span>
    </a>
    <a
        class="avmup-menu-item mat-mdc-menu-item"
        matTooltip="Afficher les informations sur l'application Hub4B"
        matTooltipPosition="left"
        matTooltipShowDelay="1000"
        (click)="openAbout()">
        <fa-icon [icon]="aboutIcon"></fa-icon>
        A Propos
    </a>
</mat-menu>
